module.exports = __webpack_public_path__ + "static/media/quiz-desenhos-para-colorir.4f03afbb.pdf";